import React, { useState } from "react";
import StarRating from "./Stars";
import * as S from "./Styles";

export interface TestimonialCardProps {
  rating: number;
  customerName: string;
  testimonial: string;
}

const CHARACTER_LIMIT = 250;

export const TestimonialCard: React.FC<TestimonialCardProps> = ({ rating, customerName, testimonial }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = testimonial.length > CHARACTER_LIMIT;
  const displayText = shouldTruncate && !isExpanded ? testimonial.slice(0, CHARACTER_LIMIT) + "..." : testimonial;

  return (
    <S.Container>
      <S.CardHeader>
        <S.GoogleLogo src="https://www.google.com/favicon.ico" alt="Google" />
        <StarRating rating={rating} />
      </S.CardHeader>
      <S.CustomerName>{customerName}</S.CustomerName>
      <S.Testimonial>{displayText}</S.Testimonial>
      {shouldTruncate && (
        <S.ShowMoreButton onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? "Vis mindre" : "Vis mer"}
        </S.ShowMoreButton>
      )}
    </S.Container>
  );
};
